export const TOOLTIP_TEST_ID = "TURBO_TOOLTIP";
export const TOOLTIP_CLOSE_ICON_TEST_ID = "TURBO_TOOLTIP_CLOSE_ICON";
